namespace RedBullMOBILE360.Sms {
    export interface ExclusiveOffersRow {
        Id?: number;
        OfferId?: string;
        ExclusiveOfferId?: string;
        IsEnabled?: number;
    }

    export namespace ExclusiveOffersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OfferId';
        export const localTextPrefix = 'Sms.ExclusiveOffers';
        export const deletePermission = 'Sms:ExclusiveOffers';
        export const insertPermission = 'Sms:ExclusiveOffers';
        export const readPermission = 'Sms:ExclusiveOffers';
        export const updatePermission = 'Sms:ExclusiveOffers';

        export declare const enum Fields {
            Id = "Id",
            OfferId = "OfferId",
            ExclusiveOfferId = "ExclusiveOfferId",
            IsEnabled = "IsEnabled"
        }
    }
}
